import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import {
    Agricultura_1,
    Construccion_1,
    Industrial_1,
    Oem_1,
    ResiduosReciclaje_1
} from '../../assets/images';

const Industries = () => {
    const industriesList = [
        {
            id: 1,
            name: 'Agricultura',
            slug: 'agricultura',
            description: 'Maquinaria agrícola desde 1945. Ofrecemos soluciones de alto rendimiento con sistemas preventivos integrales para no interrumpir tu operación.',
            image: Agricultura_1,
            alt: 'Maquinaria JCB para Agricultura - Manipuladores telescópicos y cargadores frontales para labores del campo'
        },
        {
            id: 2,
            name: 'Construcción',
            slug: 'construccion',
            description: 'Desde 1953, la retroexcavadora JCB revolucionó la industria. Hoy contamos con más de 300 máquinas operando en seis continentes.',
            image: Construccion_1,
            alt: 'Maquinaria JCB para Construcción - Retroexcavadoras, excavadoras y minicargadores para obra'
        },
        {
            id: 3,
            name: 'Industrial',
            slug: 'industrial',
            description: 'Logística eficiente y efectiva para el movimiento y almacenamiento de mercancías desde su punto de origen hasta su consumo.',
            image: Industrial_1,
            alt: 'Maquinaria JCB para Industrial - Montacargas Teletruk y equipos de logística para almacenes'
        },
        {
            id: 4,
            name: 'Residuos y Reciclaje',
            slug: 'reciclaje-y-residuos',
            description: 'La mayor gama de máquinas concebidas para satisfacer sus necesidades de manipulación con soluciones Wastemaster.',
            image: ResiduosReciclaje_1,
            alt: 'Maquinaria JCB para Residuos y Reciclaje - Soluciones Wastemaster para plantas de reciclaje'
        },
        {
            id: 5,
            name: 'Soluciones OEM',
            slug: 'oem',
            description: 'Componentes y sistemas personalizados para integración en equipos especializados de cualquier sector.',
            image: Oem_1,
            alt: 'Maquinaria JCB Soluciones OEM - Componentes y sistemas personalizados para equipos especializados'
        }
    ];

    return (
        <div className="container mx-auto px-6 py-24">
            <Helmet>
                <title>Industrias que Atendemos | JCB Azteca</title>
                <meta name="description" content="Soluciones JCB para construcción, agricultura, industrial, reciclaje y OEM. Maquinaria especializada por sector productivo en el sureste de México." />
                <meta name="keywords" content="JCB industrias, maquinaria construcción, maquinaria agricultura, equipos industriales, reciclaje, soluciones OEM, JCB Azteca" />
                <link rel="canonical" href="https://azteca-site.org/industries" />

                <meta property="og:type" content="website" />
                <meta property="og:title" content="Industrias que Atendemos | JCB Azteca" />
                <meta property="og:description" content="Soluciones JCB para construcción, agricultura, industrial, reciclaje y OEM." />
                <meta property="og:url" content="https://azteca-site.org/industries" />
                <meta property="og:image" content="https://azteca-site.org/og/industrias-jcb-azteca.jpg" />
                <meta property="og:locale" content="es_MX" />
                <meta property="og:site_name" content="JCB Azteca" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Industrias que Atendemos | JCB Azteca" />
                <meta name="twitter:description" content="Soluciones JCB para construcción, agricultura, industrial, reciclaje y OEM." />
                <meta name="twitter:image" content="https://azteca-site.org/og/industrias-jcb-azteca.jpg" />

                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "CollectionPage",
                        "name": "Industrias que Atendemos | JCB Azteca",
                        "url": "https://azteca-site.org/industries",
                        "description": "Soluciones JCB para construcción, agricultura, industrial, reciclaje y OEM.",
                        "inLanguage": "es-MX",
                        "isPartOf": {
                            "@type": "WebSite",
                            "name": "JCB Azteca",
                            "url": "https://azteca-site.org/"
                        },
                        "hasPart": [
                            {
                                "@type": "WebPage",
                                "name": "Agricultura",
                                "url": "https://azteca-site.org/industries/agricultura",
                                "description": "Maquinaria agrícola JCB desde 1945 para siembra, cosecha y manejo de forrajes."
                            },
                            {
                                "@type": "WebPage",
                                "name": "Construcción",
                                "url": "https://azteca-site.org/industries/construccion",
                                "description": "Retroexcavadoras, excavadoras y minicargadores JCB para construcción."
                            },
                            {
                                "@type": "WebPage",
                                "name": "Industrial",
                                "url": "https://azteca-site.org/industries/industrial",
                                "description": "Montacargas Teletruk y equipos de logística JCB para almacenes y puertos."
                            },
                            {
                                "@type": "WebPage",
                                "name": "Residuos y Reciclaje",
                                "url": "https://azteca-site.org/industries/reciclaje-y-residuos",
                                "description": "Soluciones Wastemaster JCB para plantas de reciclaje y centros de acopio."
                            },
                            {
                                "@type": "WebPage",
                                "name": "Soluciones OEM",
                                "url": "https://azteca-site.org/industries/oem",
                                "description": "Componentes y sistemas personalizados JCB para equipos especializados."
                            }
                        ]
                    })}
                </script>
            </Helmet>

            <nav className="text-sm mb-12" aria-label="Breadcrumb">
                <Link to="/" className="text-text-muted hover:text-dark-primary">Inicio</Link>
                <span className="mx-2 text-text-muted">/</span>
                <span className="text-dark-primary font-medium">Industrias</span>
            </nav>

            <div className="max-w-3xl mb-12">
                <h1 className="text-4xl md:text-5xl font-display font-bold text-dark-primary mb-4">
                    Industrias que Servimos
                </h1>
                <p className="text-text-muted text-lg">
                    En JCB Azteca ofrecemos soluciones especializadas para diferentes sectores industriales,
                    con maquinaria adaptada a las necesidades específicas de cada industria.
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {industriesList.map((industry) => (
                    <Link
                        key={industry.id}
                        to={`/industries/${industry.slug}`}
                        className="group bg-white border border-border-subtle hover:shadow-lg transition-all duration-300 overflow-hidden"
                        title={`${industry.name} | JCB Azteca`}
                    >
                        <div className="grid grid-cols-1 md:grid-cols-3">
                            <div className="md:col-span-1 aspect-square md:aspect-auto overflow-hidden bg-surface-subtle">
                                <img
                                    src={industry.image}
                                    alt={industry.alt}
                                    title={`JCB Azteca | ${industry.name}`}
                                    loading="lazy"
                                    width="400"
                                    height="400"
                                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                />
                            </div>
                            <div className="md:col-span-2 p-6 md:p-8 flex flex-col justify-center">
                                <h3 className="font-display text-xl font-bold text-dark-primary group-hover:text-jcb-yellow transition-colors mb-2">
                                    {industry.name}
                                </h3>
                                <p className="text-text-muted text-sm mb-4 line-clamp-3">
                                    {industry.description}
                                </p>
                                <span className="inline-flex items-center font-display text-xs uppercase tracking-luxury text-dark-primary group-hover:text-jcb-yellow transition-colors">
                                    Conocer más
                                    <svg
                                        className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                        aria-hidden="true"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                </span>
                            </div>
                        </div>
                    </Link>
                ))}
            </div>

            <div className="mt-16 bg-dark-primary p-8 md:p-12 text-center">
                <h2 className="text-2xl font-display font-bold text-white mb-4">
                    ¿No encuentras lo que buscas?
                </h2>
                <p className="text-white/80 mb-6 max-w-2xl mx-auto">
                    Contáctanos y descubre cómo podemos adaptar nuestras soluciones a las necesidades específicas de tu industria.
                </p>
                <Link
                    to="/contact"
                    className="inline-flex items-center justify-center font-display text-xs uppercase tracking-luxury font-medium bg-jcb-yellow text-dark-primary hover:bg-yellow-500 px-8 py-3 transition-all duration-300"
                    title="Contactar a JCB Azteca"
                >
                    Contactar ahora
                </Link>
            </div>
        </div>
    );
};

export default Industries;